import React, { useState, useEffect, useRef } from "react";
import "./Study.css";
import Footer from "../Footer/Footer";
import Header from "../Header/Header";
import parse from "html-react-parser";
import Spinner from "../Spinner/Spinner";
import { Button } from "react-bootstrap";
import { withRouter } from "react-router";
import { post } from "../../app/shared/http";
import { withAuth } from "../../app/util/HOC";
import { Editor } from "@tinymce/tinymce-react";
import StudyCenterHeader from "./StudyCenterHeader";
import { makeStyles } from "@material-ui/core/styles";
import { handleException } from "../../app/util/util";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import loaderColors1 from "../Spinner/loaderColors1.gif";
import ButtonToolbar from "react-bootstrap/ButtonToolbar";
import { usePagination } from "@material-ui/lab/Pagination";
var userVORole;
let questionType = "";
const useStyles = makeStyles({
  ul: {
    listStyle: "none",
    padding: 0,
    margin: 0,
    display: "flex",
  },
});
export function StudyShortAnswerStudent(props) {
  const userVO = JSON.parse(localStorage.getItem("userVO"));
  const keepMeLogIn = localStorage.getItem("keepLoggedIn") ? "true" : "false";
  const [bookVO, setBookVO] = useState(
    JSON.parse(localStorage.getItem("bookVO")),
  );
  const classes = useStyles();
  const editorRef = useRef("");
  const [loName, setLoName] = useState("");
  const [isLoading, setisLoading] = useState(false);
  const [questionVO, setQuestionVO] = useState(null);
  const [shortAnswer, setShortAnswer] = useState("");
  const [correctbtn, setCorrectBtn] = useState(false);
  const [practicebtn, setPracticeBtn] = useState(false);
  const [incorrectbtn, setIncorrectBtn] = useState(false);
  const [saveBtnChanges, setSaveBtnChanges] = useState("");
  const [currentQuestion, setCurrentQuestion] = useState(null);
  const [totalQuestionCount, setTotalQuestionCount] = useState(0);
  const [btnFlagText, setbtnFlagText] = useState("Flag For Later");
  const [questionBankVOList, setQuestionBankVOList] = useState(null);
  const [questionResponseVO, setQuestionResponseVO] = useState(null);
  useEffect(() => {
    async function fetchQuestions(questionType) {
      userVORole = userVO.userRole;
      let reqData = {
        userVO: {
          userId: userVO.userId,
          userActivityVO: {
            lastActivityCode: "BOOKSHELF",
            pageNavigatingFrom: "BOOKSHELF",
            pageNavigatingTo: "BOOKSHELF",
          },
          sessionVO: {
            appType: "web",
            browserName: localStorage.getItem("browserName"),
            deviceMacId: "",
            deviceOS: localStorage.getItem("deviceOS"),
            deviceType: localStorage.getItem("deviceType"),
            keepMeLoggedInFlag: keepMeLogIn,
            sessionAuthenticationToken: userVO.sessionAuthenticationToken,
          },
          userRole: userVO.userRole,
          userRoleId: userVO.userRoleId,
        },
        bookVO: {
          bookISBN: props.match.params.isbn,
        },
        questionVO: {
          questionType: questionType,
          classId: -999,
          chapterId: props.match.params.chapterid,
          learningObjectId: props.match.params.loid,
          bookISBN: props.match.params.isbn,
          limit: localStorage.getItem("sumOfAllQuestions"),
        },
      };
      const requestOptions1 = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(reqData),
      };
      setisLoading(true);
      fetch(
        localStorage.getItem("ENV") +
          "/assessmentRetrievalService/getQuestionForStudyCenterLearnRv",
        requestOptions1,
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.status === "true") {
            if (data) {
              var loName = data.learningObjName;
              if (data.assessmentVO && data.assessmentVO.questionBankVOList) {
                data.bookVO.chapterId = props.match.params.chapterid;
                data.assessmentVO.questionBankVOList = Array.isArray(
                  data.assessmentVO.questionBankVOList,
                )
                  ? data.assessmentVO.questionBankVOList
                  : [data.assessmentVO.questionBankVOList];
                setQuestionBankVOList(data.assessmentVO.questionBankVOList);
                if (
                  data.assessmentVO.questionBankVOList[0].questionResponseVO
                    .status == "correct"
                ) {
                  setPracticeBtn(false);
                  setIncorrectBtn(false);
                  setCorrectBtn(true);
                } else if (
                  data.assessmentVO.questionBankVOList[0].questionResponseVO
                    .status == "incorrect"
                ) {
                  setPracticeBtn(false);
                  setIncorrectBtn(true);
                  setCorrectBtn(false);
                } else if (
                  data.assessmentVO.questionBankVOList[0].questionResponseVO
                    .status == "partial"
                ) {
                  setPracticeBtn(true);
                  setIncorrectBtn(false);
                  setCorrectBtn(false);
                } else {
                  setPracticeBtn(false);
                  setIncorrectBtn(false);
                  setCorrectBtn(false);
                }
                setTotalQuestionCount(
                  data.assessmentVO.countOfTotalQuestion
                    ? data.assessmentVO.countOfTotalQuestion
                    : "1",
                );
                data.assessmentVO.questionBankVOList.map((quesBank) => {
                  if (
                    quesBank.currentQuestionFlag === quesBank.questionNumber
                  ) {
                    setQuestionResponseVO(quesBank.questionResponseVO);
                    setCurrentQuestion(quesBank);
                    setQuestionVO(quesBank.questionVO);
                    setShortAnswer(getAttemptedShortAnswer(quesBank));
                    updateCurrentQuestionBtn(quesBank.questionNumber);
                  }
                });
                setBookVO(data.bookVO);
                setLoName(loName);
                setisLoading(false);
              }
            }
          } else {
            if (data.wkErrorCode) {
              handleException(data);
            }
          }
        })
        .catch((error) => {
          console.error(
            "There has been a problem with your fetch operation:",
            error,
          );
          setisLoading(false);
        });
    }
    questionType = props.match.path.split("/")[4];
    if (questionType === "shortanswer") {
      questionType = "hypothetical";
    } else if (questionType === "essay") {
      questionType = "essay";
    }
    fetchQuestions(questionType);
  }, []);
  const navigateToChapterInsights = (e) => {
    if (userVORole === "Professor") {
      props.history.push(
        `/study/${props.match.params.isbn}/${props.match.params.chapterid}`,
      );
    }
  };
  const navigateToStudyDashboard = (e) => {
    if (userVORole === "Professor") {
      props.history.push(`/study/${props.match.params.isbn}`);
    } else if (userVORole === "Student") {
      props.history.push(
        `/study/${props.match.params.isbn}/${props.match.params.chapterid}`,
      );
    }
  };
  const getQuestion = (e) => {
    if (
      parseInt(totalQuestionCount - 1) ===
      parseInt(e.target.getAttribute("arrayIndex"))
    ) {
      document
        .getElementById(
          `btnQuestion_${parseInt(currentQuestion.questionNumber) + 1}`,
        )
        .focus();
    }
    if (
      e.target.getAttribute("arrayIndex") !== undefined &&
      questionBankVOList[parseInt(e.target.getAttribute("arrayIndex"))]
    ) {
      setCurrentQuestion(
        questionBankVOList[parseInt(e.target.getAttribute("arrayIndex"))],
      );
      setShortAnswer(
        getAttemptedShortAnswer(
          questionBankVOList[parseInt(e.target.getAttribute("arrayIndex"))],
        ),
      );
      var cques =
        questionBankVOList[parseInt(e.target.getAttribute("arrayIndex"))];
      setbtnFlagText(
        cques.questionResponseVO.flagged === "false"
          ? "Flag For Later"
          : "Flagged",
      );
      if (
        questionBankVOList[parseInt(e.target.getAttribute("arrayIndex"))]
          .questionResponseVO.status == "correct"
      ) {
        setPracticeBtn(false);
        setIncorrectBtn(false);
        setCorrectBtn(true);
      } else if (
        questionBankVOList[parseInt(e.target.getAttribute("arrayIndex"))]
          .questionResponseVO.status == "incorrect"
      ) {
        setPracticeBtn(false);
        setIncorrectBtn(true);
        setCorrectBtn(false);
      } else if (
        questionBankVOList[parseInt(e.target.getAttribute("arrayIndex"))]
          .questionResponseVO.status == "partial"
      ) {
        setPracticeBtn(true);
        setIncorrectBtn(false);
        setCorrectBtn(false);
      } else {
        setPracticeBtn(false);
        setIncorrectBtn(false);
        setCorrectBtn(false);
      }
      updateCurrentQuestionBtn(
        parseInt(e.target.getAttribute("arrayIndex")) + 1,
        e.currentTarget.innerText,
      );
    }
  };
  const submitAnswerShortAnswer = (e, accessMsg) => {
    var contentAns = editorRef.current && editorRef.current.getBody();
    setSaveBtnChanges(`Content Typed in the Editor ${accessMsg} Successfully`);
    if (
      contentAns.innerHTML !== undefined &&
      contentAns.innerText !== undefined &&
      contentAns.innerText.trim() !== "" &&
      e.target
    ) {
      var action =
        e.target && e.target.getAttribute("action")
          ? e.target.getAttribute("action")
          : "NA";
      let reqData = {
        userVO: {
          userId: userVO.userId,
          userActivityVO: {
            lastActivityCode: "BOOKSHELF",
            pageNavigatingTo: "BOOKSHELF",
            pageNavigatingFrom: "BOOKSHELF",
          },
          sessionVO: {
            appType: "web",
            deviceMacId: "",
            keepMeLoggedInFlag: keepMeLogIn,
            deviceOS: localStorage.getItem("deviceOS"),
            deviceType: localStorage.getItem("deviceType"),
            browserName: localStorage.getItem("browserName"),
            sessionAuthenticationToken: userVO.sessionAuthenticationToken,
          },
          userRole: userVO.userRole,
          userRoleId: userVO.userRoleId,
        },
        assessmentVO: {
          questionVO: {
            answerVOList: [
              {
                questionId: currentQuestion.questionVO.questionId,
                responseText: editorRef.current.getBody().innerHTML,
              },
            ],
            saveFlag:
              (e.target && e.target.getAttribute("action")) === "submit"
                ? 0
                : 1,
          },
        },
      };
      const requestOptions1 = {
        method: "POST",
        body: JSON.stringify(reqData),
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      };
      fetch(
        localStorage.getItem("ENV") +
          "/manageAssessmentService/submitQuestionResponse",
        requestOptions1,
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.status === "true") {
            if (questionBankVOList) {
              if (questionBankVOList[currentQuestion.questionNumber - 1]) {
                var tempQuestionBankVOList = questionBankVOList;
                var attemptedAnswerVOList = {
                  responseText: editorRef.current.getBody()
                    ? editorRef.current.getBody().innerHTML
                    : "",
                };
                tempQuestionBankVOList[
                  currentQuestion.questionNumber - 1
                ].questionResponseVO.attemptedAnswerVOList =
                  attemptedAnswerVOList;
                if (action === "submit")
                  tempQuestionBankVOList[
                    currentQuestion.questionNumber - 1
                  ].questionResponseVO.status = "answered";
                setQuestionBankVOList(tempQuestionBankVOList);
                setSaveBtnChanges("");
              }
            }
            setShortAnswer(
              editorRef.current.getBody()
                ? editorRef.current.getBody().innerHTML
                : "",
            );
          } else if (data.wkErrorCode) {
            handleException(data);
          }
        })
        .catch((error) => {
          console.error(
            "There has been a problem with your fetch operation:",
            error,
          );
        });
    }
  };
  const getAttemptedShortAnswer = (currQuestion) => {
    if (currQuestion.questionResponseVO.attemptedAnswerVOList) {
      let givenAnswer =
        currQuestion.questionResponseVO.attemptedAnswerVOList.responseText;
      givenAnswer = givenAnswer !== "" ? givenAnswer : "";
      return givenAnswer;
    } else {
      if (
        editorRef !== null &&
        editorRef.current &&
        editorRef.current.getBody()
      )
        editorRef.current.getBody().innerHTML = "";
      return "";
    }
  };
  const updateCurrentQuestionBtn = (questionNumber, btnName) => {
    document.querySelectorAll(".questionNumberBtn").forEach((x) => {
      x.classList.remove("active-question-btn");
    });
    if (document.getElementById("btnQuestion_" + questionNumber - 1)) {
      document
        .getElementById("btnQuestion_" + questionNumber - 1)
        .classList.remove("active-question-btn");
      document.getElementById(
        "btnQuestion_" + questionNumber - 1,
      ).style.border = "inherit";
    }
    if (document.getElementById("btnQuestion_" + questionNumber + 1)) {
      document
        .getElementById("btnQuestion_" + questionNumber + 1)
        .classList.remove("active-question-btn");
      document.getElementById(
        "btnQuestion_" + questionNumber + 1,
      ).style.border = "inherit";
    }
    if (btnName === "Skip" || btnName === "Next") {
      if (document.getElementById("btnQuestion_" + questionNumber))
        document
          .getElementById("btnQuestion_" + questionNumber)
          .classList.add("active-question-btn");
      document
        .querySelectorAll(".questionNumberBtn")
        .forEach((x) => (x.style.border = "inherit"));
    }
  };
  const updateGradeShortAnswerEssay = (e) => {
    let grade = 0;
    if (e.target.getAttribute("myKnowledge") === "correct") {
      grade = 1;
      setPracticeBtn(false);
      setIncorrectBtn(false);
      setCorrectBtn(true);
    } else if (e.target.getAttribute("myKnowledge") === "incorrect") {
      grade = 0;
      setPracticeBtn(false);
      setIncorrectBtn(true);
      setCorrectBtn(false);
    } else if (e.target.getAttribute("myKnowledge") === "partial") {
      grade = 2;
      setPracticeBtn(true);
      setIncorrectBtn(false);
      setCorrectBtn(false);
    } else {
      setPracticeBtn(false);
      setIncorrectBtn(false);
      setCorrectBtn(false);
    }
    var currQuestion = currentQuestion;
    var selectedOption = "";
    if (currQuestion.questionResponseVO.attemptedAnswerVOList)
      selectedOption =
        currQuestion.questionResponseVO.attemptedAnswerVOList.optionNumber;
    let reqData = {
      userVO: {
        userId: userVO.userId,
        userActivityVO: {
          lastActivityCode: "BOOKSHELF",
          pageNavigatingFrom: "BOOKSHELF",
          pageNavigatingTo: "BOOKSHELF",
        },
        sessionVO: {
          appType: "web",
          browserName: localStorage.getItem("browserName"),
          deviceMacId: "",
          deviceOS: localStorage.getItem("deviceOS"),
          deviceType: localStorage.getItem("deviceType"),
          keepMeLoggedInFlag: keepMeLogIn,
          sessionAuthenticationToken: userVO.sessionAuthenticationToken,
        },
        userRole: userVO.userRole,
        userRoleId: userVO.userRoleId,
      },
      assessmentVO: {
        questionVO: {
          questionType: questionType,
          questionId: currentQuestion.questionVO.questionId,
          optionNumber: "",
          answerVOList: [
            {
              responseText:
                editorRef.current &&
                editorRef.current.getBody() &&
                editorRef.current.getBody().innerHTML,
            },
          ],
          grade: grade,
          chapterId: props.match.params.chapterid,
          learningObjectId: props.match.params.loid,
          questionNumber: currentQuestion.questionNumber,
        },
      },
    };
    const requestOptions1 = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(reqData),
    };
    fetch(
      localStorage.getItem("ENV") +
        "/manageAssessmentService/saveQuestionResponse",
      requestOptions1,
    )
      .then((response) => response.json())
      .then((data) => {
        if (data) {
          if (data.status === "true") {
            let btn = document.getElementById(
              "btnQuestion_" + currentQuestion.questionNumber,
            );
            if (grade === 0) {
              currQuestion.questionResponseVO.status = "incorrect";
              btn.className = "numberBox redBgColor btn btn-primary";
              setPracticeBtn(false);
              setIncorrectBtn(true);
              setCorrectBtn(false);
            } else if (grade === 1) {
              currQuestion.questionResponseVO.status = "correct";
              btn.className = "numberBox greenBgColor btn btn-primary";
              setPracticeBtn(false);
              setIncorrectBtn(false);
              setCorrectBtn(true);
            } else if (grade === 2) {
              currQuestion.questionResponseVO.status = "partial";
              btn.className = "numberBox blueBgColor btn btn-primary";
              setPracticeBtn(true);
              setIncorrectBtn(false);
              setCorrectBtn(false);
            } else {
              setPracticeBtn(false);
              setIncorrectBtn(false);
              setCorrectBtn(false);
            }
            setCurrentQuestion(currQuestion);
          } else {
            if (data.wkErrorCode) {
              handleException(data);
            }
          }
        }
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  };
  const flagQuestion = (e) => {
    let reqData = {
      userVO: {
        userId: userVO.userId,
        userActivityVO: {
          lastActivityCode: "BOOKSHELF",
          pageNavigatingFrom: "BOOKSHELF",
          pageNavigatingTo: "BOOKSHELF",
        },
        sessionVO: {
          appType: "web",
          browserName: localStorage.getItem("browserName"),
          deviceMacId: "",
          deviceOS: localStorage.getItem("deviceOS"),
          deviceType: localStorage.getItem("deviceType"),
          keepMeLoggedInFlag: keepMeLogIn,
          sessionAuthenticationToken: userVO.sessionAuthenticationToken,
        },
        userRole: userVO.userRole,
        userRoleId: userVO.userRoleId,
      },
      assessmentVO: {
        questionVO: {
          questionType: questionType,
          questionId: currentQuestion.questionVO.questionId,
          flagValue: e.target.getAttribute("flagValue") === "true" ? "0" : "1",
        },
      },
    };
    const requestOptions1 = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(reqData),
    };
    fetch(
      localStorage.getItem("ENV") +
        "/manageAssessmentService/saveFlagUnflagStatus",
      requestOptions1,
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "true") {
          if (data) {
            var currQuestion = currentQuestion;
            currQuestion.questionResponseVO.flagged =
              e.target.getAttribute("flagValue") === "true" ? "false" : "true";
            setCurrentQuestion(currQuestion);
            setbtnFlagText(
              currQuestion.questionResponseVO.flagged === "false"
                ? "Flag For Later"
                : "Flagged",
            );
          }
        } else {
          if (data.wkErrorCode) {
            handleException(data);
          }
        }
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  };
  const { items } = usePagination({
    count: totalQuestionCount,
    pageProp: questionBankVOList,
    boundaryCount: 2,
    onChange: (e) => getQuestion(e),
  });
  useEffect(() => {
    const fetchImgForCurrentQuestion = async () => {
      const currentQuestionImg = document.querySelector(
        'img[src*="questionimages/"]',
      );
      if (currentQuestionImg) {
        let relativeUrl = `/casebook/questionimages${currentQuestionImg.src.split("/questionimages")[1]}`;
        relativeUrl = relativeUrl.split("?")[0];
        let reqData = {
          genericServiceRequestVO: { inputBaseUrl: relativeUrl },
        };
        try {
          const data = await (
            await post("/manageUrlService/getCDNUrl", reqData, "ENV")
          ).json();
          if (data.status === "true") {
            currentQuestionImg.src = data.genericServiceResponseVO.cdnUrl;
            currentQuestionImg.style.maxHeight = "250px";
            currentQuestionImg.style.maxWidth = "100%";
          } else if (data.wkErrorCode) {
            handleException(data);
          }
        } catch (error) {
          console.error(
            "There has been a problem with your fetch operation:",
            error,
          );
        }
      }
    };
    fetchImgForCurrentQuestion();
  }, [currentQuestion]);
  const handleBackToStudyCenter = (e) => {
    if (e.key === "Enter") {
      navigateToStudyDashboard(e);
    }
  };
  const handleNavigateToChapterInsights = (e) => {
    if (e.key === "Enter") {
      navigateToChapterInsights();
    }
  };
  return (
    <React.Fragment>
      <Header userVO={userVO} bookVO={bookVO} pageName="study"></Header>
      <StudyCenterHeader userVO={userVO} />
      <div className="col-lg-12">
        <div className="row greyDiv">
          <div className="col-xl-8 col-lg-7 col-md-5 col-sm-12 col-xs-12 headingDiv">
            <span className="insightProperty">
              {userVORole == "Professor" ? "Student Preview : " : null}
              {loName}
            </span>
            <br />
            <span className="insightHeading">
              {questionType === "essay" ? "Essay" : "Short Answer"}
            </span>
            <br />
            <div style={{ display: "flex" }}>
              <div
                className="studyLink cusorPointer"
                onClick={navigateToStudyDashboard}
                tabIndex="0"
                onKeyDown={(e) => handleBackToStudyCenter(e)}
              >
                {" "}
                Back to Study Center{" "}
              </div>
              {userVORole == "Professor" ? (
                <div style={{ display: "contents" }}>
                  <i
                    className="fa fa-angle-right"
                    aria-hidden="true"
                    style={{
                      padding: "0% 1%",
                      fontWeight: "bold",
                      fontSize: "14px",
                    }}
                  ></i>
                  <span
                    className="studyLink cusorPointer"
                    onClick={navigateToChapterInsights}
                    tabIndex="0"
                    onKeyDown={(e) => handleNavigateToChapterInsights(e)}
                  >
                    {" "}
                    Chapter Insights
                  </span>
                </div>
              ) : null}
            </div>
          </div>
          <div
            className="col-xl-4 col-lg-5 col-md-7 col-sm-12 col-xs-12"
            style={{ margin: "auto" }}
          >
            <ButtonToolbar
              aria-label="Toolbar with button groups"
              style={{ justifyContent: "center" }}
            >
              <ButtonGroup className="mr-2" aria-label="First group">
                <ul className={classes.ul}>
                  {items.map(({ page, type, selected, ...item }, index) => {
                    let children = null;
                    if (type === "start-ellipsis" || type === "end-ellipsis") {
                      if (
                        totalQuestionCount != "1" &&
                        parseInt(totalQuestionCount) > 6
                      ) {
                        children = (
                          <i
                            style={{ margin: "15px 5px 0 0" }}
                            className="fa fa-ellipsis-h"
                            aria-hidden="true"
                          ></i>
                        );
                      }
                    } else if (type === "page") {
                      if (
                        questionBankVOList !== null &&
                        questionBankVOList !== undefined
                      ) {
                        if (
                          questionBankVOList[page - 1].questionResponseVO !==
                            null &&
                          questionBankVOList[page - 1].questionResponseVO !==
                            undefined
                        ) {
                          if (
                            questionBankVOList[page - 1].questionResponseVO
                              .status === "incorrect"
                          ) {
                            children = (
                              <span>
                                <button
                                  {...item}
                                  style={{
                                    color: selected ? "#000000" : undefined,
                                    border: selected
                                      ? "1px solid #000"
                                      : undefined,
                                  }}
                                  arrayIndex={page - 1}
                                  id={
                                    "btnQuestion_" +
                                    questionBankVOList[page - 1].questionNumber
                                  }
                                  aria-label={`View question ${questionBankVOList[page - 1].questionNumber}`}
                                  className="questionNumberBtn numberBox redBgColor"
                                >
                                  {page}
                                </button>{" "}
                                &nbsp;&nbsp;{" "}
                              </span>
                            );
                          } else if (
                            questionBankVOList[page - 1].questionResponseVO
                              .status === "correct"
                          ) {
                            children = (
                              <span>
                                <button
                                  {...item}
                                  style={{
                                    color: selected ? "#000000" : undefined,
                                    border: selected
                                      ? "1px solid #000"
                                      : undefined,
                                  }}
                                  arrayIndex={page - 1}
                                  id={
                                    "btnQuestion_" +
                                    questionBankVOList[page - 1].questionNumber
                                  }
                                  aria-label={`View question ${questionBankVOList[page - 1].questionNumber}`}
                                  className="questionNumberBtn numberBox greenBgColor"
                                >
                                  {page}
                                </button>
                                &nbsp;&nbsp;{" "}
                              </span>
                            );
                          } else if (
                            questionBankVOList[page - 1].questionResponseVO
                              .status === "partial"
                          ) {
                            children = (
                              <span>
                                <button
                                  {...item}
                                  style={{
                                    color: selected ? "#000000" : undefined,
                                    border: selected
                                      ? "1px solid #000"
                                      : undefined,
                                  }}
                                  arrayIndex={page - 1}
                                  id={
                                    "btnQuestion_" +
                                    questionBankVOList[page - 1].questionNumber
                                  }
                                  aria-label={`View question ${questionBankVOList[page - 1].questionNumber}`}
                                  className="questionNumberBtn numberBox blueBgColor"
                                >
                                  {page}
                                </button>
                                &nbsp;&nbsp;{" "}
                              </span>
                            );
                          } else {
                            children = (
                              <span>
                                <button
                                  {...item}
                                  style={{
                                    color: selected ? "#007AC3" : undefined,
                                    border: selected
                                      ? "1px solid #000"
                                      : undefined,
                                  }}
                                  arrayIndex={page - 1}
                                  id={
                                    "btnQuestion_" +
                                    questionBankVOList[page - 1].questionNumber
                                  }
                                  aria-label={`View question ${questionBankVOList[page - 1].questionNumber}`}
                                  className="questionNumberBtn numberBox"
                                >
                                  {page}
                                </button>
                                &nbsp;&nbsp;{" "}
                              </span>
                            );
                          }
                        }
                      }
                    }
                    return <li key={index}>{children}</li>;
                  })}
                </ul>
              </ButtonGroup>
            </ButtonToolbar>
          </div>
        </div>
        <div className="row">
          <Spinner
            loading={isLoading}
            imageSrc={loaderColors1}
            overlayBackground="rgba(0,0,0,0.7)"
            label="Loading short answer questions"
          />
          <div className="studyDiv">
            {currentQuestion !== null ? (
              <div className="col-lg-12">
                {currentQuestion.questionResponseVO ? (
                  currentQuestion.questionResponseVO.endorseQuestionFlag ===
                  "1" ? (
                    <div className="shortanswerColor">
                      <span className="insightProperty">
                        Your professor endorses this question.
                      </span>
                    </div>
                  ) : null
                ) : null}
                {currentQuestion &&
                currentQuestion.questionVO.studyAidVOList &&
                !Array.isArray(currentQuestion.questionVO.studyAidVOList) &&
                currentQuestion.questionVO.studyAidVOList.studyAidTitle &&
                currentQuestion.questionVO.studyAidVOList.studyAidLink ? (
                  <span>
                    {" "}
                    From
                    <span className="studyLink">
                      &nbsp;{" "}
                      <a
                        href={
                          currentQuestion.questionVO.studyAidVOList.studyAidLink
                        }
                        target="__blank"
                      >
                        {
                          currentQuestion.questionVO.studyAidVOList
                            .studyAidTitle
                        }
                      </a>
                    </span>
                  </span>
                ) : null}
                <div className="shortanswerht">
                  <span
                    className="insightProperty"
                    style={{ fontFamily: "Arial" }}
                  >
                    {currentQuestion.questionVO !== null
                      ? parse(currentQuestion.questionVO.questionText)
                      : ""}
                  </span>
                </div>
                <div className="" id="studySAEditorId">
                  <Editor
                    id="answerTextArea"
                    onInit={(evt, editor) => (editorRef.current = editor)}
                    apiKey="0pf9aw3is77mhjeluerke3yzvxj13f9yocjczeumortsxfg5"
                    init={{
                      selector: "textarea",
                      theme: "silver",
                      mobile: {
                        theme: "mobile",
                        plugins: "autosave lists autolink",
                        toolbar: [
                          "undo",
                          "redo",
                          "bold",
                          "italic",
                          "bullist",
                          "numlist",
                          "outdent",
                          "indent",
                          "styleselect",
                        ],
                      },
                      plugins:
                        "lists fullscreen template directionality noneditable advlist nonbreaking",
                      toolbar1:
                        "undo redo | fontselect fontsizeselect | bold italic underline | alignleft aligncenter alignright alignjustify | sectionButton | bullist numlist | outdent indent | forecolor backcolor | removeHighlight",
                      menubar: false,
                      directionality: "ltr",
                      toolbar_items_size: "medium",
                      extended_valid_elements: "a[href|onclick]",
                      fontsize_formats:
                        "10px 12px 14px 18px 24px 36px 48px 64px",
                      font_formats:
                        "Andale Mono=andale mono,times;" +
                        "Arial=arial,helvetica,sans-serif;" +
                        "Arial Black=arial black,avant garde;" +
                        "Book Antiqua=book antiqua,palatino;" +
                        "Comic Sans MS=comic sans ms,sans-serif;" +
                        "Courier New=courier new,courier;" +
                        "Georgia=georgia,palatino;" +
                        "Helvetica=helvetica;" +
                        "Impact=impact,chicago",
                      entity_encoding: "named",
                      resize: "true",
                      statusbar: false,
                      height: 250,
                      marginBottom: 10,
                      paddingleft: 10,
                      marginLeft: 50,
                      nonbreaking_force_tab: false,
                      toolbar: "ltr rtl  bullist numlist",
                      forced_root_block: "p",
                      force_br_newlines: false,
                      force_p_newlines: true,
                      paste_auto_cleanup_on_paste: false,
                      theme_advanced_resizing: true,
                      theme_advanced_resize_horizontal: false,
                    }}
                    initialValue={shortAnswer}
                    aria-label="Rich Text Editor"
                    disabled={
                      (currentQuestion.questionResponseVO &&
                        currentQuestion.questionResponseVO.status &&
                        currentQuestion.questionResponseVO.status !==
                          "not attempted") ||
                      (currentQuestion.questionResponseVO
                        .attemptedAnswerVOList &&
                        !Array.isArray(
                          currentQuestion.questionResponseVO
                            .attemptedAnswerVOList,
                        ) &&
                        currentQuestion.questionResponseVO.attemptedAnswerVOList
                          .saveFlag &&
                        currentQuestion.questionResponseVO.attemptedAnswerVOList
                          .saveFlag === "0")
                        ? true
                        : false
                    }
                  />
                  <div
                    aria-live="assertive"
                    aria-relevant="additions text"
                    style={{ position: "absolute", left: "-9999px" }}
                  >
                    {saveBtnChanges}
                  </div>
                </div>
                <br></br>
                <div className="row">
                  <div className="col-lg-12">
                    <Button
                      className="submitSaveButton nextStudy"
                      action="submit"
                      disabled={
                        (currentQuestion.questionResponseVO &&
                          currentQuestion.questionResponseVO.status &&
                          currentQuestion.questionResponseVO.status !==
                            "not attempted") ||
                        (currentQuestion.questionResponseVO
                          .attemptedAnswerVOList &&
                          !Array.isArray(
                            currentQuestion.questionResponseVO
                              .attemptedAnswerVOList,
                          ) &&
                          currentQuestion.questionResponseVO
                            .attemptedAnswerVOList.saveFlag &&
                          currentQuestion.questionResponseVO
                            .attemptedAnswerVOList.saveFlag === "0")
                          ? true
                          : false
                      }
                      onClick={(e) => submitAnswerShortAnswer(e, "Submitted")}
                    >
                      Submit
                    </Button>{" "}
                    &nbsp;&nbsp;
                    <Button
                      className="submitSaveButton nextStudy"
                      action="save"
                      disabled={
                        (currentQuestion.questionResponseVO &&
                          currentQuestion.questionResponseVO.status &&
                          currentQuestion.questionResponseVO.status !==
                            "not attempted") ||
                        (currentQuestion.questionResponseVO
                          .attemptedAnswerVOList &&
                          !Array.isArray(
                            currentQuestion.questionResponseVO
                              .attemptedAnswerVOList,
                          ) &&
                          currentQuestion.questionResponseVO
                            .attemptedAnswerVOList.saveFlag &&
                          currentQuestion.questionResponseVO
                            .attemptedAnswerVOList.saveFlag === "0")
                          ? true
                          : false
                      }
                      onClick={(e) => submitAnswerShortAnswer(e, "Saved")}
                    >
                      Save
                    </Button>
                    <hr />
                  </div>
                </div>
                {(currentQuestion.questionResponseVO &&
                  currentQuestion.questionResponseVO.status &&
                  currentQuestion.questionResponseVO.status !==
                    "not attempted") ||
                (currentQuestion.questionResponseVO.attemptedAnswerVOList &&
                  !Array.isArray(
                    currentQuestion.questionResponseVO.attemptedAnswerVOList,
                  ) &&
                  currentQuestion.questionResponseVO.attemptedAnswerVOList
                    .saveFlag &&
                  currentQuestion.questionResponseVO.attemptedAnswerVOList
                    .saveFlag === "0") ? (
                  <div className="rationSection">
                    <br />{" "}
                    <span className="insightHeading">
                      Rationale for Correct Answer
                    </span>
                    <br />
                    <br />
                    <span
                      className="insightProperty"
                      style={{ fontFamily: "Arial" }}
                    >
                      {parse(currentQuestion.questionVO.generalFeedback)}
                    </span>
                    <br />
                  </div>
                ) : null}
                <div className="myKnowledgeSection">
                  <div className="rightSideButtonSet">
                    {totalQuestionCount !== currentQuestion.questionNumber ? (
                      <Button
                        className="myKnowledgeSectionButton enrollButton"
                        arrayIndex={currentQuestion.questionNumber}
                        aria-label="Next question"
                        onClick={(e) => getQuestion(e)}
                      >
                        Next
                      </Button>
                    ) : null}{" "}
                    &nbsp;
                    <Button
                      id="btnFlag"
                      variant="outline-secondary"
                      aria-label={
                        currentQuestion.questionResponseVO.flagged == "false"
                          ? "Flag this question for later"
                          : "Unflag this question"
                      }
                      aria-pressed={currentQuestion.questionResponseVO.flagged}
                      flagValue={currentQuestion.questionResponseVO.flagged}
                      onClick={(e) => flagQuestion(e)}
                      className="myKnowledgeSectionButton studyButton nextStudy"
                    >
                      {btnFlagText}
                    </Button>
                  </div>
                  <div className="leftSideButtonSet">
                    {(currentQuestion.questionResponseVO &&
                      currentQuestion.questionResponseVO.status &&
                      currentQuestion.questionResponseVO.status !==
                        "not attempted") ||
                    (currentQuestion.questionResponseVO.attemptedAnswerVOList &&
                      !Array.isArray(
                        currentQuestion.questionResponseVO
                          .attemptedAnswerVOList,
                      ) &&
                      currentQuestion.questionResponseVO.attemptedAnswerVOList
                        .saveFlag &&
                      currentQuestion.questionResponseVO.attemptedAnswerVOList
                        .saveFlag === "0") ? (
                      <div>
                        <div className="textHead">
                          My knowledge on this question is:
                        </div>
                        {correctbtn == true ? (
                          <Button
                            aria-selected="true"
                            aria-label="My knowledge on this question is: Correct"
                            className="myKnowledgeSectionButton correctprimaryactive"
                            myKnowledge="correct"
                            onClick={(e) => updateGradeShortAnswerEssay(e)}
                          >
                            Correct
                          </Button>
                        ) : (
                          <Button
                            aria-selected="false"
                            aria-label="My knowledge on this question is: Correct"
                            className="myKnowledgeSectionButton studyButton correctprimary"
                            myKnowledge="correct"
                            o
                            onClick={(e) => updateGradeShortAnswerEssay(e)}
                          >
                            Correct
                          </Button>
                        )}
                        {incorrectbtn == true ? (
                          <Button
                            aria-selected="true"
                            aria-label="My knowledge on this question is: Incorrect"
                            className="myKnowledgeSectionButton incorrectprimaryactive ml-3"
                            myKnowledge="incorrect"
                            onClick={(e) => updateGradeShortAnswerEssay(e)}
                          >
                            Incorrect
                          </Button>
                        ) : (
                          <Button
                            aria-selected="false"
                            aria-label="My knowledge on this question is: Incorrect"
                            className="myKnowledgeSectionButton studyButton incorrectprimary ml-3"
                            myKnowledge="incorrect"
                            onClick={(e) => updateGradeShortAnswerEssay(e)}
                          >
                            Incorrect
                          </Button>
                        )}
                        {practicebtn == true ? (
                          <Button
                            aria-selected="true"
                            aria-label="My knowledge on this question is: Needs Practice"
                            className="myKnowledgeSectionButton needsmoreactive ml-3"
                            myKnowledge="partial"
                            onClick={(e) => updateGradeShortAnswerEssay(e)}
                          >
                            Needs Practice
                          </Button>
                        ) : (
                          <Button
                            aria-selected="false"
                            aria-label="My knowledge on this question is: Needs Practice"
                            className="myKnowledgeSectionButton studyButton needsmore ml-3"
                            myKnowledge="partial"
                            onClick={(e) => updateGradeShortAnswerEssay(e)}
                          >
                            Needs Practice
                          </Button>
                        )}
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            ) : null}
            <br />
            <br />
            <br />
            <br />
            <div>
              <span className="insightHeading">
                About the Connected eBook Study Center
              </span>
              <br /> <br />
              <span className="insightProperty">
                The content in the Study Center is selected and maintained
                exclusively by Aspen Publishing and a team of professor
                reviewers and editors, not by the authors of your book. These
                materials typically come from one or more of Aspen Publishing's
                top study aids, including Examples & Explanations, Glannon
                Guides, Emanuel Law Outlines, and Emanuel Law in a Flash, or may
                be created with assistance from AI tools. Study material sources
                and activity types vary depending on availability for any given
                chapter, topic, or course.
              </span>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </React.Fragment>
  );
}
export default withAuth(withRouter(StudyShortAnswerStudent));
